<template>
  <div class="box8">
    <Title :title="'提现记录'"></Title>
    <div class="search">
      <div class="flex">
        <p>流水号</p>
        <input type="text" placeholder="流水号" class="inputStyle" v-model="search.withdrawId">
      </div>
      <div class="flex">
        <p>提现金额</p>
        <input min="0" type="number" placeholder="提现金额" class="inputStyle" v-model="search.minMoney"
          @blur="orderNumberStartBlur" style="margin-right: 10px;">
        <p>至</p>
        <input min="0" type="number" placeholder="提现金额" class="inputStyle" v-model="search.maxMoney"
          @blur="orderNumberEndBlur">
      </div>
      <div class="flex">
        <p>选择时间</p>
        <DatePicker type="date" placeholder="开始时间"
          style="width: 150px;margin-right: 10px;margin-bottom: 8px;margin-top: 8px;" v-model="search.createStartTime"
          @on-change="handelDateChangeStart"></DatePicker>
        <p>至</p>
        <DatePicker type="date" placeholder="结束时间" style="width: 150px;margin-bottom: 8px;margin-top: 8px;"
          v-model="search.createEndTime" @on-change="handelDateChangeEnd"></DatePicker>
      </div>
      <!-- 操作按钮 -->
      <el-button style="margin-left:12px" type="warning" @click="onFormSearch">查询</el-button>
      <el-button type="warning" plain @click="onFormReset">重置</el-button>
    </div>
    <div class="table">
      <el-table v-loading="listLoading" :data="tableData" style="width: 100%" :highlight-current-row="true"
        :header-cell-style="{ background: '#FCFAF8', fontSize: '16px', fontFamily: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi', fontWeight: 'normal', color: '#222222' }">
        <el-table-column label="序号" type="index" align="center" width="58">
        </el-table-column>
        <el-table-column label="流水号" prop="withdrawId" align="center" min-width="130px">
        </el-table-column>
        <el-table-column label="真实姓名" prop="realname" align="center" min-width="140px">
        </el-table-column>
        <el-table-column label="支付宝账户" prop="withdrawAccount" align="center" min-width="170px">
        </el-table-column>
        <el-table-column label="银行卡号" prop="bankCardNum" align="center" min-width="150px">
        </el-table-column>
        <el-table-column label="提现金额" prop="moneyStr" align="center" min-width="120px">
        </el-table-column>
        <el-table-column label="提现状态" prop="statusStr" align="center" min-width="220px" fixed="right">
          <template slot-scope="{row}">
            <!-- <div class="status" :class="[{'active': row.status === 0}]"> -->
            <!-- {{row.status | toStatus }} -->
            <!-- </div> -->
            {{ row.statusStr }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <Page :total="total" :current="pageNo" show-sizer show-elevator show-total @on-change="changePage"
        @on-page-size-change="changePagesize"></Page>
    </div>
  </div>
</template>

<script>
import Title from './components/title.vue'
import { DatePicker, Page } from 'view-design'
import { getRecordList } from '@/api/user.js'
import { getUserUUID } from '@/utils/auth'
import { getDate } from '@/utils/date'

export default {
  name: '',
  components: { Title, DatePicker, Page },
  props: {},
  data() {
    return {
      search: {},
      listLoading: true,
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          status: 0,
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          status: 0,
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          status: 1,
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          status: 1,
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ],
      total: 0,
      pageNo: 1,
      pageSize: 10
    }
  },
  filters: {
    toStatus(status) {
      switch (status) {
        case 0:
          return '提现失败（提现失败收款账号不存在或户名有误，建议核实账号和户名是否准确）'
        case 1:
          return '提现成功'

        default:
          break
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.$store.commit('nav/SET_ACTIVE_slideActive', 1)
    this.getList()
  },
  mounted() { },
  activated() { },
  deactivated() { },
  destroyed() { },
  methods: {
    getList() {
      this.listLoading = true
      let userParam = {
        createEndTime: getDate(this.search.createEndTime),
        createStartTime: getDate(this.search.createStartTime)
      }
      if (userParam.createStartTime) {
        userParam.createStartTime = userParam.createStartTime + ' 00:00:00'
      } else {
        delete userParam.createStartTime
      }
      if (userParam.createEndTime) {
        userParam.createEndTime = userParam.createEndTime + ' 23:59:59'
      } else {
        delete userParam.createEndTime
      }
      getRecordList({
        withdrawId: this.search.withdrawId,
        ...userParam,
        maxMoney: this.search.maxMoney,
        minMoney: this.search.minMoney,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        userUUID: getUserUUID()
      }).then(res => {
        console.log('res', res)
        this.tableData = res.data.list
        if (res.data.pageNo === 0) {
          this.total = 0
          this.pageNo = 1
        } else {
          this.total = res.data.total
          this.pageNo = res.data.pageNo
          this.pageSize = res.data.pageSize
        }
        this.listLoading = false
      }).catch(err => {
        this.tableData = []
        this.listLoading = false
        this.total = 0
        this.pageNo = 1
      })
    },
    // 重置
    onFormReset() {
      this.search.timeStart = ''
      this.search.timeEnd = ''
      this.search.createStartTime = ''
      this.search.createEndTime = ''
      this.search.maxMoney = ''
      this.search.minMoney = ''
      this.search.withdrawId = ''
      this.onFormSearch()
    },
    //查询
    onFormSearch() {
      this.pageNo = 1
      this.getList()
    },
    handelDateChangeStart(time, type) {
      if (type == 'date') {
        if (this.search.timeEnd !== '') {
          if (this.compareTime(time, this.search.timeEnd)) {
            this.search.timeStart = this.search.timeEnd
          }
        }
      }
    },
    handelDateChangeEnd(time, type) {
      if (type == 'date') {
        if (this.search.timeStart !== '') {
          if (this.compareTime(this.search.timeStart, time)) {
            this.search.timeEnd = this.search.timeStart
          }
        }
      }
    },
    compareTime(startTime, endTime) {
      var oDate1 = new Date(startTime)
      var oDate2 = new Date(endTime)
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    },
    orderNumberStartBlur() {
      if (this.search.orderNumberEnd) {
        if (this.search.orderNumberStart > this.search.orderNumberEnd) {
          this.search.orderNumberStart = this.search.orderNumberEnd
        }
      }
    },
    orderNumberEndBlur() {
      if (this.search.orderNumberStart) {
        if (this.search.orderNumberStart > this.search.orderNumberEnd) {
          this.search.orderNumberEnd = this.search.orderNumberStart
        }
      }
    },
    changePage(value) {
      console.log(value)
      this.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      console.log(value)
      this.pageSize = value
      this.getList()
    }
  }
}
</script>
<style lang='less' scoped>
.box8 {
  width: 100%;

  @media(max-width: 1200px) {
    min-width: 1000px !important;
  }

  .search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin-top: 20px;

    p {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-right: 10px;
    }

    ::placeholder {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #c1c1c1;
    }

    .inputStyle {
      box-sizing: border-box;
      width: 150px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      padding-left: 10px;
      margin-right: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
    }

    :hover {
      border-color: #57a3f3;
    }

    .searchBtn {
      width: 90px;
      height: 32px;
      background: #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      line-height: 32px;
      color: rgba(255, 255, 255, 0.8);
      // margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
      cursor: pointer;
    }
  }

  .table {
    border: 1px solid #eeeeee;
    margin-top: 30px;

    .status {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
    }

    .active {
      color: #ff4f76;
    }
  }

  .page {
    // margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/user/WithdrawalRecord.vue